<template>
  <div class="card level dolmetscher-bar bottom-bar" style="overflow: auto; justify-content: space-between">
    <b-loading :active="!testDataChannelOk"></b-loading>
    <div
      v-if="testDataChannelOk"
      class="flex"
      style="display: flex; flex-direction: column; align-items: start; justify-content: center; margin-left: 40px"
    >
      <!-- top bar -->
      <div class="level-item" style="flex-grow: 0">
        <b-field id="tt-step-13" class="mb-0 mr-2">
          <b-button v-if="translatorReady == false" class="ready" @click="$emit('is-ready')">
            {{ $t("translatorReadyBtn").toUpperCase() }}
          </b-button>
          <b-tooltip v-if="translatorReady == true && onAir == false" :label="$t('onAirTooltip')" animated>
            <b-button class="go-onair" :class="{ active: localMute != true }" @click="$emit('toggle-mute')">
              {{ localMute ? "GO ON AIR" : $t("onAirBtn").toUpperCase() }}
            </b-button>
          </b-tooltip>
          <b-button
            v-if="onAir == true"
            class="on-air"
            :class="{ active: localMute != true }"
            :label="$t('onAirBtn').toUpperCase()"
            icon-right="access-point"
            @click="$emit('toggle-mute')"
          >
          </b-button>
        </b-field>
        <b-field class="has-text-centered trans-btn-group mb-0 ml-2">
          <b-field id="tt-step-10" grouped position="is-right" class="mb-0" style="align-items: center; width: 100%">
            <b-tooltip :label="$t('requestHandoverDesc')" position="is-right" multilined animated>
              <div v-if="!passiveRequestPending && !passiveRequestAccepted">
                <div class="over-btn-text" style="color: #333333 !important">
                  {{ $t("handover").toUpperCase() }}
                </div>
                <b-button
                  size="is-medium"
                  type="is-light"
                  style="color: #333; font-weight: bold; margin-bottom: 18px"
                  icon-left="send"
                  @click="sendHandoverRequest"
                >
                  <div style="font-size: 14px">Send</div>
                </b-button>
              </div>
            </b-tooltip>
            <div v-if="passiveRequestPending || passiveRequestAccepted">
              <div class="over-btn-text" style="color: #333333 !important">
                {{ $t("handover").toUpperCase() }}
              </div>
              <b-button
                size="is-medium"
                type="is-light"
                style="color: #333; font-weight: bold; margin-bottom: 18px; margin-right: 5px"
                :class="{
                  'is-bubblegum': passiveRequestPending,
                  'is-apple': passiveRequestAccepted,
                }"
                icon-left="account-switch-outline"
              >
                <div style="font-size: 14px; margin-bottom: 5px">
                  {{ passiveRequestStatus }}
                </div>
              </b-button>
            </div>
          </b-field>
        </b-field>
        <div class="handover-texts" style="max-width: 200px">
          <div v-if="activeOnAir && (passiveRequestAccepted || activeRequestAccepted)">
            <b>{{ $t("pressOnAirButton") }}</b>
            <br />
          </div>
          <div v-else-if="activeOnAir">
            <b>{{ activeOnAir.displayName.toUpperCase() }} {{ $t("isCurrentlyTranslating") }}</b>
          </div>
        </div>
      </div>
      <!-- bottom bar -->
      <div class="level-item mt-4" style="max-width: 600px; align-items: flex-end; flex-grow: 0">
        <b-field class="has-text-centered trans-btn-group mb-0 mr-2" :label="$t('output').toUpperCase()">
          <b-field grouped position="is-right" style="align-items: flex-start; width: 100%">
            <!-- Mic toggle button -->
            <b-tooltip
              class=""
              :label="localMute ? $t('unmuteDesc') : $t('muteDesc')"
              position="is-top"
              multilined
              animated
            >
              <div>
                <b-button
                  id="tt-step-9"
                  class="no-br-right"
                  size="is-medium"
                  :icon-right="localMute ? 'microphone-off' : 'microphone'"
                  :type="localMute ? 'is-light' : 'is-danger is-light'"
                  @click="$emit('toggle-mute')"
                />
                <div class="under-btn-spacer"></div>
              </div>
            </b-tooltip>
            <!-- Video toggle button -->
            <b-tooltip
              class=""
              :label="vidPaused ? $t('unmuteVideoDesc') : $t('muteVideoDesc')"
              position="is-top"
              multilined
              animated
            >
              <div>
                <b-button
                  id="tt-step-9"
                  class="no-br-left"
                  size="is-medium"
                  :icon-right="vidPaused ? 'video-off' : 'video'"
                  :type="vidPaused ? 'is-light' : 'is-danger is-light'"
                  @click="$emit('toggle-video-mute')"
                />
                <div class="under-btn-spacer"></div>
              </div>
            </b-tooltip>
          </b-field>
        </b-field>
        <b-field class="has-text-centered trans-btn-group mb-0 mr-2" :label="$t('outputLang').toUpperCase()">
          <b-field grouped position="is-right" style="align-items: flex-start; width: 100%">
            <b-tooltip :label="$t('toggleOutputLangDesc')" position="is-top" multilined animated>
              <div style="display: flex; margin-bottom: 25.7px">
                <!-- <b-button
                  id="tt-step-8"
                  class="no-br-left is-light"
                  size="is-medium"
                  icon-left="sync"
                  @click="$emit('toggle-current-output-lang')"
                /> -->
                <div
                  id="tt-step-8"
                  class="right-btn-text has-text-centered mx-2"
                  style="line-height: 45px; text-transform: uppercase"
                >
                  <div style="display: inline-block; vertical-align: middle">
                    <div
                      :class="clientTranslator.lang1 == clientTranslator.currentOutputLang ? 'crnt-output' : ''"
                      :style="{
                        color: clientTranslator.lang1 == clientTranslator.currentOutputLang ? '#ff0082' : '#CCCCCC',
                      }"
                      style="
                        font-weight: bold;
                        letter-spacing: 0.5px;
                        line-height: 14px;
                        text-align: center;
                        margin-bottom: 10px;
                        cursor: pointer;
                      "
                      @click="emitToggleOutputLangEvent1"
                    >
                      {{ clientTranslator.lang1 }}
                    </div>
                    <div
                      :class="clientTranslator.lang2 == clientTranslator.currentOutputLang ? 'crnt-output' : ''"
                      :style="{
                        color: clientTranslator.lang2 == clientTranslator.currentOutputLang ? '#ff0082' : '#CCCCCC',
                      }"
                      style="
                        font-weight: bold;
                        letter-spacing: 0.5px;
                        line-height: 14px;
                        text-align: center;
                        cursor: pointer;
                      "
                      @click="emitToggleOutputLangEvent2"
                    >
                      {{ clientTranslator.lang2 }}
                    </div>
                  </div>
                </div>
              </div>
            </b-tooltip>
          </b-field>
        </b-field>
        <!-- Listen booth partner button -->
        <div>
          <b-field>
            <b-tooltip :label="$t('hearPartnerTranslator')" position="is-top" multilined animated>
              <b-button
                class="mx-3"
                size="is-medium"
                type="is-light"
                style="padding-left: 14px; width: 50px; max-width: 50px; padding-right: 14px; color: #333"
                :class="{ 'is-apple': hearOtherTranslator }"
                @click="$emit('toggle-hear-other-translator')"
              >
                <b-icon icon="call-merge" />
              </b-button>
            </b-tooltip>
          </b-field>
          <div class="under-btn-spacer"></div>
        </div>
        <b-field class="ml-3 has-text-centered trans-btn-group" :label="$t('input').toUpperCase()">
          <b-field grouped position="is-right" style="align-items: center; width: 100%">
            <b-tooltip
              v-for="(l, i) in settingsRelayLang"
              :key="l"
              :label="isRelayLangOnAir(l) ? $t('hearRelayDesc') + ' - ' + l.toUpperCase() : $t('noRelayAvailable')"
              position="is-top"
              animated
            >
              <div>
                <b-button
                  size="is-medium"
                  type="is-light"
                  style="padding-left: 14px; width: 50px; max-width: 50px; padding-right: 14px"
                  :class="{
                    'is-apple': consumeLang == l.toUpperCase(),
                    'no-br-left': i != 0,
                    'no-br-right': i == 0,
                    'active-relay': isRelayLangOnAir(l),
                  }"
                  @click="toggleRelayInputLang(l.toUpperCase())"
                >
                  <div style="font-size: 12px; font-weight: bold; color: #333">
                    {{ l.toUpperCase() }}
                  </div>
                </b-button>
                <div class="under-btn-text" style="color: #333333 !important">
                  {{ $t("relay").toUpperCase() }}
                </div>
              </div>
            </b-tooltip>
            <div v-if="langWhiteList.filter((l) => !settingsRelayLang.includes(l)).length > 0">
              <b-dropdown aria-role="list" position="is-top-left">
                <button slot="trigger" class="button is-medium is-light no-br-left">
                  <b-icon icon="dots-horizontal" />
                </button>

                <b-dropdown-item
                  v-for="l in langWhiteList.filter((l) => !settingsRelayLang.includes(l))"
                  :key="l"
                  aria-role="listitem"
                  @click="switchRelayLang(l)"
                >
                  {{ l.toUpperCase() }}
                </b-dropdown-item>
              </b-dropdown>
              <div class="under-btn-text" style="color: #333333 !important">
                {{ $t("more").toUpperCase() }}
              </div>
            </div>
            <b-tooltip class="ml-2" :label="$t('hearFloorDesc')" position="is-top" multilined animated>
              <div>
                <b-button
                  size="is-medium"
                  type="is-light"
                  class=""
                  style="color: #333"
                  :class="{ 'is-apple': listenFloor }"
                  icon-left="account-voice"
                  @click="$emit('toggle-floor')"
                />
                <div class="under-btn-text" style="color: #333333 !important">
                  {{ $t("floor").toUpperCase() }}
                </div>
              </div>
            </b-tooltip>
          </b-field>
        </b-field>
      </div>
    </div>

    <!-- slider -->
    <div v-if="testDataChannelOk" class="slider-container">
      <div class="slider-sub-container">
        <div class="slider-label">
          {{ $t("partnerTranslatorVolume").toUpperCase() }}
        </div>
        <div class="volume-slider">
          <a>
            <b-icon icon="volume-low" @click.native="otherTranslatorVolume = 0"></b-icon>
          </a>
          <vue-slider
            v-model="otherTranslatorVolume"
            :adsorb="true"
            :interval="5"
            :contained="true"
            :width="260"
            dot-size="16"
            direction="ltr"
          ></vue-slider>
          <a>
            <b-icon icon="volume-high" @click.native="otherTranslatorVolume = 100"></b-icon>
          </a>
        </div>
      </div>

      <div class="slider-sub-container">
        <!-- <b-tooltip :label="$t('volumeControl')" animated> -->
        <div class="slider-label">
          {{ $t("inputVolume").toUpperCase() }}
        </div>
        <div class="volume-slider">
          <a>
            <b-icon icon="volume-low" @click.native="consumeVolume = 0"></b-icon>
          </a>
          <vue-slider
            v-model="consumeVolume"
            :adsorb="true"
            :interval="5"
            :contained="true"
            :width="260"
            dot-size="16"
            direction="ltr"
          ></vue-slider>
          <a>
            <b-icon icon="volume-high" @click.native="consumeVolume = 100"></b-icon>
          </a>
        </div>
      </div>

      <div class="slider-sub-container">
        <div class="slider-label">
          {{ $t("floorVolume").toUpperCase() }}
        </div>
        <div class="volume-slider">
          <a>
            <b-icon icon="volume-low" @click.native="floorVolume = 0"></b-icon>
          </a>
          <vue-slider
            v-model="floorVolume"
            :adsorb="true"
            :interval="5"
            :contained="true"
            :width="260"
            dot-size="16"
            direction="ltr"
          ></vue-slider>
          <a>
            <b-icon icon="volume-high" @click.native="floorVolume = 100"></b-icon>
          </a>
        </div>
      </div>
    </div>
    <!-- Booth partner video -->
    <div v-if="testDataChannelOk" class="partner-video">
      <div class="video-container">
        <video ref="videoElem" width="300px" autoPlay="true" playsInline="true" muted />
        <b-select
          :placeholder="$t('selectPartnerVideo')"
          size="is-small"
          icon="account-switch"
          @input="selectPartnerVideo"
        >
          <option v-for="peer in boothPartners" :key="peer.id" :value="peer.id">
            {{ peer.displayName }}
          </option>
        </b-select>
      </div>
    </div>
    <!-- Force takeover button -->
    <div v-if="testDataChannelOk" class="forcetakeover-btn">
      <b-field class="has-text-centered trans-btn-group mb-0 ml-2" :label="$t('forceTakeover').toUpperCase()">
        <b-tooltip :label="$t('forceTakeoverDesc')" position="is-top" multilined animated>
          <b-button
            size="is-large"
            type="is-light"
            class="no-br-right"
            icon-left="alert-octagon"
            @click="openForceTakeoverDialog"
          />
        </b-tooltip>
      </b-field>
    </div>
    <!-- <v-tour
      name="translatorTour"
      :steps="tourSteps"
      :options="{
        labels: {
          buttonSkip: this.$t('buttonSkip'),
          buttonPrevious: this.$t('buttonPrevious'),
          buttonNext: this.$t('buttonNext'),
          buttonStop: this.$t('buttonStop')
        }
      }"
    /> -->
  </div>
</template>
<script>
/**
 * Overlay for the translator board which provides specific controls used for translation
 * @displayName Translator Overlay
 */
import { mapState } from "vuex";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  name: "TranslatorOverlay",
  components: {
    VueSlider,
  },
  props: {
    event: Object,
    localMute: Boolean,
    translatorReady: Boolean,
    activeWillTake: Object,
    clientTranslator: Object,
    activeOnAir: Object,
    settingsRelayLang: Array,
    langWhiteList: Array,
    relayLang: Object,
  },
  data() {
    return {
      floorVolumeOld: null,
    };
  },
  created() {
    // this.startTour();
  },
  computed: {
    ...mapState({
      testDataChannelOk: (state) => state.mediasoup.testDataChannelOk,
      peers: (state) => state.mediasoup.peers,
      videoReady: (state) => state.mediasoup.videoReady,
      consumeLang: (state) => state.mediasoup.consumeLang,
      listenFloor: (state) => state.mediasoup.listenFloor,
      consumeVolume: (state) => state.mediasoup.consumeVolume,
      floorVolume: (state) => state.mediasoup.floorVolume,
      onAir: (state) => state.mediasoup.onAir,
      hearOtherTranslator: (state) => state.mediasoup.hearOtherTranslator,
      passiveHandoverNotification: (state) => state.mediasoup.passiveHandoverNotification,
      translatorsOnAir: (state) => state.mediasoup.translatorsOnAir,
      vidPaused: (state) => state.mediasoup.vidPaused,
      openPassiveHandoverNotification: (state) => state.mediasoup.openPassiveHandoverNotification,
      openActiveHandoverNotification: (state) => state.mediasoup.openActiveHandoverNotification,
      activeRequestAnswererId: (state) => state.mediasoup.activeRequestAnswererId,
      activeRequestAnswererName: (state) => state.mediasoup.activeRequestAnswererName,
      activeRequestAccepted: (state) => state.mediasoup.activeRequestAccepted,
      activeRequestRejected: (state) => state.mediasoup.activeRequestRejected,
      activeReqDisplayName: (state) => state.mediasoup.activeReqDisplayName,
      passiveReqDisplayName: (state) => state.mediasoup.passiveReqDisplayName,
      passiveRequestAccepted: (state) => state.mediasoup.passiveRequestAccepted,
      passiveRequestRejected: (state) => state.mediasoup.passiveRequestRejected,
      passiveRequestPending: (state) => state.mediasoup.passiveRequestPending,
    }),
    /**
     * Computed property returns list of booth partner peers.
     * @private
     */
    boothPartners() {
      let allInterpreters = this.peers.filter((peer) => {
        if (peer.role === "translator") {
          return true;
        }
      });
      // console.log("File translatorOverlay, interpreters", allInterpreters);
      const boothPartners = allInterpreters.filter(
        (t) =>
          (t.clientTranslator.lang1 == this.clientTranslator.lang1 &&
            t.clientTranslator.lang2 == this.clientTranslator.lang2) ||
          (t.clientTranslator.lang1 == this.clientTranslator.lang2 &&
            t.clientTranslator.lang2 == this.clientTranslator.lang1),
      );
      // console.log("File translatorOverlay, booth partners", boothPartners);
      return boothPartners;
    },
    onAirLangs() {
      return this.$store.getters["mediasoup/getOnAirLangs"];
    },
    floorVolume: {
      get() {
        return this.$store.getters["mediasoup/floorVolume"];
      },
      set(value) {
        this.$store.commit("mediasoup/set_floor_volume", value);
      },
    },
    consumeVolume: {
      get() {
        return this.$store.getters["mediasoup/consumeVolume"];
      },
      set(value) {
        this.$store.commit("mediasoup/set_consume_volume", value);
      },
    },
    otherTranslatorVolume: {
      get() {
        return this.$store.getters["mediasoup/otherTranslatorVolume"];
      },
      set(value) {
        this.$store.commit("mediasoup/set_otherTranslator_volume", value);
      },
    },
    getOnAirLangs() {
      return this.$store.getters["mediasoup/getOnAirLangs"];
    },
    onAirPeerLangs() {
      return this.$store.getters["mediasoup/getOnAirLangsInPeers"];
    },
    // Returns passive handover request status
    passiveRequestStatus() {
      if (this.passiveRequestPending) {
        return this.$t("pending");
      } else if (this.passiveRequestAccepted) {
        return this.$t("accepted");
      }
      return null;
    },
  },
  watch: {
    activeRequestAccepted(newVal) {
      if (newVal && this.onAir) {
        this.openActiveRequestAcceptedDialog();
      }
    },
    activeRequestRejected(newVal) {
      if (newVal && this.onAir) {
        this.openActiveRequestRejectedDialog();
      }
    },
    passiveRequestAccepted(newVal) {
      if (newVal) {
        this.$store.commit("mediasoup/set_hearOtherTranslator", true);
      }
    },
    localMute: function (newVal) {
      if (!newVal) {
        this.$store.commit("mediasoup/set_translatorReady", true);
      }
    },
    openPassiveHandoverNotification(newVal) {
      if (newVal) {
        this.openPassiveHandoverDialog();
      }
    },
    openActiveHandoverNotification(newVal) {
      if (newVal) {
        this.openActiveHandoverDialog();
      }
    },
    onAirPeerLangs(newOnAirPeerLangs) {
      // console.log("file: TranslatorOverlay, onAirLangs", newOnAirPeerLangs);
      if (this.consumeLang && newOnAirPeerLangs.includes(this.consumeLang?.toLowerCase())) {
        this.$store.commit("mediasoup/set_listenFloor", false);
      } else if (!this.consumeLang) {
        this.$store.commit("mediasoup/set_listenFloor", true);
      }
    },
  },
  methods: {
    emitToggleOutputLangEvent1() {
      if (this.clientTranslator.lang1 != this.clientTranslator.currentOutputLang) {
        this.$emit("toggle-current-output-lang");
      }
    },
    emitToggleOutputLangEvent2() {
      if (this.clientTranslator.lang2 != this.clientTranslator.currentOutputLang) {
        this.$emit("toggle-current-output-lang");
      }
    },
    /**
     * Shows the selected partner video.
     * @public
     */
    selectPartnerVideo(selectedPartnerId) {
      // console.log("file: TranslatorOverlay, selected partner", selectedPartnerId);
      const stream = new MediaStream();
      // let videoConsumer = this.boothPartners[0].videoConsumer;
      let videoConsumer = null;
      const selectedPartner = this.boothPartners.filter((peer) => peer.id == selectedPartnerId);
      videoConsumer = selectedPartner[0].videoConsumer;
      this.$nextTick(function () {
        try {
          stream.addTrack(videoConsumer._track);
        } catch (error) {
          console.error("file: TranslatorOverlay.vue: ", error);
          // reseting the video element in case errors
          this.$refs.videoElem.pause();
          this.$refs.videoElem.removeAttribute("src");
          this.$refs.videoElem.load();
        }
        // console.log("file: TranslatorOverlay, videoConsumer", videoConsumer);
        this.$refs.videoElem.srcObject = stream;
        this.$refs.videoElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));
      });
    },
    sendHandoverRequest() {
      console.log("activeOnAir", this.activeOnAir);
      // Emitting handover request only if translator is ready
      if (this.clientTranslator.translatorReady) {
        if (this.onAir) {
          this.$emit("request-active-handover");
        } else if (!this.onAir && this.activeOnAir) {
          this.$emit("request-passive-handover");
          this.$store.commit("mediasoup/set_passiveRequestPending", true);
        } else {
          this.$buefy.toast.open({
            message: this.$t("noActiveOnAIrAlert"),
            type: "is-danger",
          });
        }
      } else {
        this.$buefy.toast.open({
          message: this.$t("pressReadyalert"),
          type: "is-danger",
        });
      }
    },
    isConsumeLangOnAir(currentLang) {
      for (const lang of this.getOnAirLangs) {
        if (lang.toUpperCase() === currentLang.toUpperCase()) {
          return true;
        }
      }
    },
    isRelayLangOnAir(currentLang) {
      for (const lang of this.$store.getters["mediasoup/getOnAirLangsInPeers"]) {
        if (lang.toUpperCase() === currentLang.toUpperCase()) {
          return true;
        }
      }
    },
    toggleRelayInputLang(selectedLang) {
      // console.log("file: TranslatorOverlay, consumeLang", this.consumeLang);
      // console.log("file: TranslatorOverlay, selectedLang", selectedLang);
      if (!this.consumeLang) {
        this.$store.commit("mediasoup/set_relayLang", selectedLang?.toUpperCase());
      } else if (selectedLang && selectedLang !== this.consumeLang) {
        this.$store.commit("mediasoup/set_relayLang", selectedLang?.toUpperCase());
      } else {
        this.$store.commit("mediasoup/set_relayLang", null);
      }
      if (this.isRelayLangOnAir(selectedLang) && this.consumeLang) {
        this.$store.commit("mediasoup/set_listenFloor", false);
      } else {
        this.$store.commit("mediasoup/set_listenFloor", true);
      }
      this.$emit("changed-consume-lang", this.consumeLang);
    },
    /**
     * Switch the current input language which the translator is listening to
     * @public
     */
    switchRelayLang(l) {
      // console.log("switchrelaylang");
      this.settingsRelayLang.unshift(l);
      this.settingsRelayLang.pop();
      this.$store.commit("mediasoup/set_consumeLang", l.toUpperCase());
      // console.log("activeonAir", this.activeOnAir);
    },
    // /**
    //  * Starts VueTour for translation board explanation
    //  * @public
    //  */
    // startTour() {
    //   let tourSteps = [
    //     // /*{target: '#tt-step-1', content: this.$t('translatorTourItem1')},*/ // Stellen Sie hier Ihre zu dolmetschenden Sprachen ein
    //     // {target: '#tt-step-2', content: this.$t('translatorTourItem2'), before: () => new Promise(resolve => {
    //     //   //this.$refs.eventChat.switchToTab('settings')
    //     //   resolve()
    //     // }), params: { placement: 'left' }, header: {title: this.$t('languages')}},
    //     // {target: '#tt-step-2', content: this.$t('translatorTourItem3'), before: () => new Promise(resolve => {
    //     //   //this.$refs.eventChat.switchToTab('chat')
    //     //   resolve()
    //     // }), params: { placement: 'left' }, header: {title: this.$t('chat')}},
    //     // {target: '#tt-step-4', content: this.$t('translatorTourItem4'), header: {title: this.$t('chat')}},
    //     // {target: '#tt-step-5', content: this.$t('translatorTourItem5'), header: {title: this.$t('chat')}},
    //     /*{target: '#tt-step-6', content: this.$t('translatorTourItem6'), header: {title: this.$t('languages')}},*/ // Wählen Sie hier die Floorsprache und ggf. die Relaissprachen aus. Über … können sie optional noch eine weitere Relaissprache auswählen
    //     /*{target: '#tt-step-7', content: this.$t('translatorTourItem7'), header: {title: this.$t('languages')}},*/ // Hier können Sie die Verdolmetschung Ihres Dolmetscherpartners jederzeit abhöre
    //     {
    //       target: "#tt-step-8",
    //       content: this.$t("translatorTourItem8"),
    //       header: { title: this.$t("languages") }
    //     }, //
    //     {
    //       target: "#tt-step-9",
    //       content: this.$t("translatorTourItem9"),
    //       header: { title: this.$t("mute") }
    //     },
    //     {
    //       target: "#tt-step-10",
    //       content: this.$t("translatorTourItem10"),
    //       header: { title: this.$t("handover") }
    //     },
    //     {
    //       target: "#tt-step-10",
    //       content: this.$t("translatorTourItem11"),
    //       header: { title: this.$t("handover") }
    //     },
    //     {
    //       target: "#tt-step-10",
    //       content: this.$t("translatorTourItem12"),
    //       header: { title: this.$t("handover") }
    //     },
    //     {
    //       target: "#tt-step-13",
    //       content: this.$t("translatorTourItem13"),
    //       header: { title: this.$t("ready") }
    //     }
    //   ];
    //   // add a step to explain demo functionality
    //   if (this.$route.query.demo) {
    //     tourSteps = tourSteps.concat([
    //       {
    //         target: "#tt-step-13",
    //         content: this.$t("translatorTourDemoItem1"),
    //         header: { title: this.$t("ready") }
    //       }
    //     ]);
    //   }
    //   // tourSteps = tourSteps.concat([
    //   //   {target: '#tt-step-14', content: this.$t('translatorTourItem14'), header: {title: this.$t('takeover')}},
    //   //   {target: '#tt-step-15', content: this.$t('translatorTourItem15'), header: {title: this.$t('chat')}}, // Hier können Sie per Chat mit unserem Support in Kontakt treten.)
    //   // ])
    //   this.tourSteps = tourSteps;
    //   // console.log("tourSteps are ", this.tourSteps);
    //   // // logs
    //   // console.log("thistours", this.$tours);
    //   // console.log("thistoursarray", this.$tours["translatorTour"]);
    //   // console.log("thistoursarray", this.$tours[0]);
    //   // console.log("thistoursobj", this.$tours.translatorTour);
    //   // start tour
    //   this.$nextTick().then(() => {
    //     this.$tours["translatorTour"].start();
    //   });
    // },
    /**
     * Opens the force takeover dialog
     * @public
     */
    openForceTakeoverDialog() {
      if (this.activeOnAir) {
        this.$emit("click-force-takeover");
        this.$buefy.dialog.confirm({
          title: this.$t("forceTakeover"),
          message: this.$t("confirmForceTakeover"),
          confirmText: this.$t("yesTakeover"),
          cancelText: this.$t("abortTakeover"),
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => this.$emit("confirm-force-takeover"),
          onCancel: () => this.$emit("abort-force-takeover"),
        });
      } else {
        this.$buefy.toast.open({
          message: "No active interpreter available to takeover!",
          type: "is-danger",
        });
      }
    },
    /**
     * Opens active interpretor's handover request notification dialog
     * in all booth partner's desk.
     * @private
     */
    openActiveHandoverDialog() {
      this.$buefy.dialog.confirm({
        title: `${this.$t("handoverNotificationTitle")}`,
        message: `${this.$t("boothPartner")} ${this.activeReqDisplayName.toUpperCase().bold()} ${this.$t(
          "activeHandoverNotification",
        )}`,
        confirmText: this.$t("Yes"),
        cancelText: this.$t("No"),
        type: "is-danger",
        hasIcon: true,
        canCancel: ["button"],
        onConfirm: () => this.emitAcceptActiveRequest(),
        onCancel: () => this.emitRejectActiveRequest(),
      });
    },
    emitAcceptActiveRequest() {
      console.log("emitting accept Request");
      this.$emit("accept-active-request");
      this.$store.commit("mediasoup/set_openActiveHandoverNotification", false);
    },
    emitRejectActiveRequest() {
      console.log("emitting reject Request");
      this.$emit("reject-active-request");
      this.$store.commit("mediasoup/set_openActiveHandoverNotification", false);
    },
    openPassiveHandoverDialog() {
      this.$buefy.dialog.confirm({
        title: `${this.$t("handoverNotificationTitle")}`,
        message: `${this.$t("boothPartner")} ${this.passiveReqDisplayName.toUpperCase().bold()} ${this.$t(
          "passiveHandoverNotification",
        )}`,
        confirmText: this.$t("Yes"),
        cancelText: this.$t("No"),
        type: "is-danger",
        hasIcon: true,
        canCancel: ["button"],
        onConfirm: () => this.emitAcceptPassiveRequest(),
        onCancel: () => this.emitRejectPassiveRequest(),
      });
    },
    emitAcceptPassiveRequest() {
      console.log("emitting emitAcceptPassiveRequest");
      this.$emit("accept-passive-request");
      this.$store.commit("mediasoup/set_openPassiveHandoverNotification", false);
    },
    emitRejectPassiveRequest() {
      this.$emit("reject-passive-request");
      this.$store.commit("mediasoup/set_openPassiveHandoverNotification", false);
    },
    openActiveRequestAcceptedDialog() {
      this.$buefy.dialog.confirm({
        title: `${this.$t("handoverNotificationTitle")}`,
        message: `${this.$t("boothPartner")} ${this.activeRequestAnswererName.toUpperCase().bold()} ${this.$t(
          "activeAcceptedNotification",
        )}`,
        confirmText: `Ok`,
        cancelText: this.$t("close"),
        type: "is-info",
        hasIcon: true,
        canCancel: ["button"],
        onConfirm: () => this.closeActiveRequestAcceptedDialog(),
        onCancel: () => this.closeActiveRequestAcceptedDialog(),
      });
    },
    closeActiveRequestAcceptedDialog() {
      this.$store.commit("mediasoup/set_activeRequestAccepted", false);
    },
    openActiveRequestRejectedDialog() {
      this.$buefy.dialog.confirm({
        title: `${this.$t("handoverNotificationTitle")}`,
        message: `${this.$t("boothPartner")} ${this.activeRequestAnswererName.toUpperCase().bold()} ${this.$t(
          "activeRejectedNotification",
        )}`,
        confirmText: `Ok`,
        cancelText: this.$t("close"),
        type: "is-info",
        hasIcon: true,
        canCancel: ["button"],
        onConfirm: () => this.closeActiveRequestRejectedDialog(),
        onCancel: () => this.closeActiveRequestRejectedDialog(),
      });
    },
    closeActiveRequestRejectedDialog() {
      this.$store.commit("mediasoup/set_activeRequestRejected", false);
    },
    // /**
    //  * Opens the passive handover request accepted dialog
    //  */
    // openHandoverAcceptedDialog() {
    //   this.$buefy.dialog.confirm({
    //     title: "Handover Request",
    //     message: `Active interpreter accepted handover request`,
    //     confirmText: `Ok`,
    //     type: "is-info",
    //     hasIcon: true
    //   });
    // }
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "AC";
  src: local("AC"), url(../../fonts/AC.ttf) format("truetype");
}
.active-relay {
  color: #ff0082 !important;
  // border-color: #ff0082 !important;
  border: 3px solid #ff0082 !important;
}
.bottom-bar {
  border-top: 1px solid #cccccc;
  z-index: 60001;
  position: absolute;
  bottom: 0px;
  width: 100%;
  margin-bottom: 0 !important;
  height: 15rem;
  justify-content: flex-start;
}
.mr-top-50 {
  margin-top: 50%;
}
.under-btn-spacer {
  margin-bottom: 21px;
}
.slider-container {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  width: auto;
  height: 100%;
  justify-content: center;
}
.slider-sub-container {
  display: flex;
}
.volume-slider {
  display: flex;
  width: 310px;
  margin: 10px;
  padding: 8px 12px 8px 12px;
  background-color: #e8e8e8;
  border-radius: 5px;
  .vue-slider-rail {
    background-color: #bab6b6;
  }
  .vue-slider-process {
    background-color: #333333;
    border-radius: 15px;
  }
  .vue-slider-dot-tooltip-inner {
    border-color: #333333;
    background-color: #333333;
  }
  .icon {
    color: #333333;
  }
}
.slider-label {
  width: 120px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: right;
  font-size: 10.5px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 14px;
  text-align: center;
}
.forcetakeover-btn {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.partner-video {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-left: 10px;
  // margin-top: 30px;
}
.video-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  background-color: #121c2e;
  justify-content: flex-end;
  // height: 202px;
  width: 300px;
  .select select:not([multiple]) {
    background-color: #f2f2f2;
    color: #333333;
    width: 300px;
  }
  .control .icon {
    color: #333333;
  }
}
.force-takeover {
  margin-left: 3rem !important;
}
.crnt-output {
  outline: 2px solid #ff0082;
  padding: 2px;
  border-radius: 2px;
}
</style>
